import React, { useState, useEffect, useMemo } from "react";
import _ from "lodash";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReviewList from "../components/common/reviewComponents/reviewList";
import { fetchReviews, reviewsSelector } from "../../store/slices/reviews";
import { createFilter } from "react-search-input";
import { useSelector, useDispatch } from "react-redux";
import {
  TextField,
  MenuItem,
  Typography,
  Grid,
  Box,
  Stack,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { TopicChip as Chip, TopicChip } from "../components/common/topicChip";
import CustomizeResponse from "../components/common/reviewComponents/customizeResponse";
import moment from "moment";
import { fetchGPTUsageData, logSelector, setInput } from "../../store/slices/logs";
import AppConfig from "../../appConfig";

const initialCache = {};

const Sentiments = ({
  selectedCompany,
  selectedLocation,
  userRoles,
  setSelectedLocation,
  locations,startDate, endDate
}) => {
  const [isMultiple,setIsMultiple]=useState(false)
  const [text, setText] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedExampleReviews, setSelectedExampleReviews] = useState([]);

  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [sentimentCache, setSentimentCache] = useState(initialCache);

  const [selectedReviewIds, setSelectedReviewIds] = useState([]);
  const [selectedReviewText, setSelectedReviewText] = useState([]);
  const { reviews } = useSelector(reviewsSelector);
  const { gptUsage } = useSelector(logSelector);
  const { generateResponse } = useSelector(reviewsSelector);
  const [customSettings, setCustomsettings] = useState({
    training: true,
    facts: true,
    brandVoice: false,
    executeParallel: true,
    singleReview: false,
  });
  const [selectedOption, setSelectedOption] = useState("With Text");
  const [topicType, setTopicType] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [reviewsPage, setReviewsPage] = useState(1);
  const [noOfPages, setPages] = useState(0);
  const [selectedFacts, setSelectedFacts] = useState([]);
  const [selectedBrandVoiceContainer, setSelectedBrandVoiceContainer] =
    useState(null);
  const[selectededReview,setSelectededReview]=useState(null);

  useEffect(
    () => setSelectedReviewIds([]),
    [selectedLocation, selectedCompany]
  );

  useEffect(() => {
    setText(generateResponse);
  }, [generateResponse]);

  useEffect(() => {
    setText("");
  }, [selectedReviewIds]);
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const getSortedReviews = () => {
    if (reviews && reviews.length > 0) {
      return _.sortBy(_.cloneDeep(reviews), ["reviewDateTime"], ["desc"]);
    } else {
      return [];
    }
  };
  const handleLocationChange = (event) => {
    const locationId = event.target.value;
    const selectedLocation = locations.find(
      (location) => location.locationId === locationId
    );
    setSelectedLocation(locationId);
    handleCloseUserMenu();
  };
  const sortedReviews = React.useMemo(
    () => getSortedReviews(),
    [reviews, startDate, endDate]
  );

  const dispatch = useDispatch();
// console.log('selectedReviewIds',selectedReviewIds)
  const handleCheckboxChange = (reviewId, reviewText) => {
    if (isMultiple) {
      if (selectedReviewIds.includes(reviewId)) {
        setSelectedReviewIds(selectedReviewIds.filter((id) => id !== reviewId));
        setSelectedReviewText(
          selectedReviewText.filter((text) => text !== reviewText)
        );
      } else {
        setSelectedReviewIds([...selectedReviewIds, reviewId]);
        setSelectedReviewText([...selectedReviewText, reviewText]);
      }
    } else {
      if (selectedReviewIds.includes(reviewId)) {
        setSelectedReviewIds(selectedReviewIds.filter((id) => id !== reviewId));
        setSelectedReviewText(
          selectedReviewText.filter((text) => text !== reviewText)
        );
      } else {
        setSelectedReviewIds([reviewId]);
        setSelectedReviewText([reviewText]);
      }
      setSelectedExampleReviews([]);
    }
  };


  // useEffect(() => {
  //   if (
  //     selectedCompany !== null &&
  //     selectedCompany !== undefined &&
  //     selectedCompany !== "" &&
  //     startDate !== null &&
  //     startDate !== undefined &&
  //     startDate !== "" &&
  //     endDate !== null &&
  //     endDate !== undefined &&
  //     endDate !== ""
  //   ) {
  //     dispatch(fetchReviews(startDate, endDate, selectedCompany));
  //   }
  // }, [selectedCompany, startDate, endDate]);

  useEffect(() => {
    setSearchTerm("");
    setSelectedExampleReviews([]);
  }, [selectedLocation, startDate, endDate, sortedReviews]);

  useEffect(() => {
    if (selectedCompany) {
    dispatch(setInput( { ["PromptType"]: 'Sentiments' }))
    }
  }, [selectedCompany]);
  const bindTopics = (review) => {
    return _.map(review?.topics, (a, index) =>
      a.topic !== "" ? (
        <TopicChip
        sx={{ml:2}}
        className={
          a?.sentiment === "Positive" ? "positive-chip" : "negative-chip"
        }
        key={index}
        //  color={a?.sentiment == "Positive" ? "success" : "error"}
        label={a?.topic}
      />
      ) : (
        ""
      )
    );
  };

  const bindfinalData = (data) => {
    return _.map(_.cloneDeep(data), (it, index) => {
      const topicData = _.map(it?.topicData?.split("|"), (ob) => {
        const [topic, sentiment] = ob?.split(":");
        return { topic, sentiment };
      });
      it["topics"] = topicData;
      it["topicElement"] = bindTopics(it);
      return it;
    });
  };
  const KEYS_TO_FILTERS = ["responseText", "reviewText", "author"];
  const prepareFinalData = (data) => {
    let cloneData = bindfinalData(data);
    let filterData = cloneData;
    switch (selectedOption) {
      case "With Text":
        filterData = _.filter(filterData, (a) => a.reviewText != null);
        break;
      case "Without Text":
        filterData = _.filter(filterData, (a) => a.reviewText == null);
        break;
      case "With Response":
        filterData = _.filter(filterData, (a) => a.responseText != null);
        break;
      case "Without Response":
        filterData = _.filter(filterData, (a) => a.responseText == null);
        break;
    }
    if (selectedLocation != "all") {
      filterData = _.filter(
        filterData,
        (a) => a.locationId == selectedLocation
      );
    }
    if (searchTerm) {
      filterData = filterData.filter(createFilter(searchTerm, KEYS_TO_FILTERS));
    }

    return _.orderBy(filterData, "reviewDateTime", "desc");
  };

  const finalData = React.useMemo(
    () => prepareFinalData(sortedReviews),
    [sortedReviews, selectedOption, selectedLocation, searchTerm]
  );
  //======Pagination======//
  const itemsPerPage = useMemo(() => 50, []);

  useEffect(() => {
    setPages(Math.ceil(finalData?.length / itemsPerPage));
  }, [finalData]);

  //===Pagination end====//
  
  return (
    <div>
            <Grid container columns={5}>
              <Grid
                item
                xs={2}
                sx={{
                  borderRight: (theme) => `1px solid ${theme.palette.divider}`,
                }}
              >
                <ReviewList
                  data={sortedReviews}
                  startDate={startDate}
                  endDate={endDate}
                  selectedCompany={selectedCompany}
                  selectedLocation={selectedLocation}
                  singleSelectFunction={handleCheckboxChange}
                  isSentiment={true}
                  isMultiple={isMultiple}
                  selectedReviewIds={selectedReviewIds}
                  setSelectedReviewIds={setSelectedReviewIds}
                  setSelectedReviewText={setSelectedReviewText}
                  reviewHeight={133}
                  setSelectedReview={setSelectededReview}
                  selectededReview={selectededReview}
                />
              </Grid>

              <Grid item xs={3}>
                <div>
                  <div>
                    <div>
                      <div style={{ paddingLeft: "16px", marginTop: "8px" }}>
                        <CustomizeResponse
                        boxHeight={150}
                          selectedCompany={selectedCompany}
                          setSelectedReviewIds={setSelectedReviewIds}
                          setSelectedReviewText={setSelectedReviewText}
                          selectedReviewText={selectedReviewText}
                          selectedReviewIds={selectedReviewIds}
                          setRefresh={setRefresh}
                          refresh={refresh}
                          gptUsage={gptUsage}
                          selectedId={selectedId}
                          setSelectedId={setSelectedId}
                          text={text}
                          setText={setText}
                          selectedExampleReviews={selectedExampleReviews}
                          selectedFacts={selectedFacts}
                          customSettings={customSettings}
                          setCustomsettings={setCustomsettings}
                          selectedBrandVoiceContainer={
                            selectedBrandVoiceContainer
                          }
                          sentimentCache={sentimentCache}
                          setSentimentCache={setSentimentCache}
                          isSentiment={true}
                          setSelectedBrandVoiceContainer={
                            setSelectedBrandVoiceContainer
                          }
                          setTopicType={setTopicType}
                          topicType={topicType}
                          isMultiple={isMultiple}
                          setIsMultiple={setIsMultiple}
                          selectededReview={selectededReview}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
    </div>
  );
};

export default Sentiments;
